class FormatMask {
  setPhoneFormatMask(phoneToFormat) {
    if(!phoneToFormat || phoneToFormat.length < 12){
      return phoneToFormat;
    }

    const number = ("" + phoneToFormat).replace(/\D/g, "");

    // US/CA: 1 + 3 + 3 + 4 (e.g., 15556187045)
    if (number.length === 11 && number.startsWith("1")) {
      const phoneNumberFormatted = number.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
      if (!phoneNumberFormatted) {
        return phoneToFormat;
      }
      return (
        "+" +
        phoneNumberFormatted[1] +
        " (" +
        phoneNumberFormatted[2] +
        ") " +
        phoneNumberFormatted[3] +
        "-" +
        phoneNumberFormatted[4]
      );
    }

    if (number.length <= 12) {
      const phoneNumberFormatted = number.match(/^(\d{2})(\d{2})(\d{4})(\d{4})$/);
      if (!phoneNumberFormatted) {
        return phoneToFormat;
      }
      return (
        "+" +
        phoneNumberFormatted[1] +
        " (" +
        phoneNumberFormatted[2] +
        ") " +
        phoneNumberFormatted[3] +
        "-" +
        phoneNumberFormatted[4]
      );
    }else if(number.length === 13){
      const phoneNumberFormatted = number.match(/^(\d{2})(\d{2})(\d{5})(\d{4})$/);
      if (!phoneNumberFormatted) {
        return phoneToFormat;
      }
      return (
        "+" +
        phoneNumberFormatted[1] +
        " (" +
        phoneNumberFormatted[2] +
        ") " +
        phoneNumberFormatted[3] +
        "-" +
        phoneNumberFormatted[4]
      );
    } else {
      return phoneToFormat;
    }

    return null;
  }

  removeMask(number) {
    const filterNumber = number.replace(/\D/g, "");
    return filterNumber;
  }

  maskPhonePattern(phoneNumber){
    if(phoneNumber.length < 13){
      return '🇧🇷 (99) 9999 9999';
    }else{
      return '🇧🇷 (99) 99999 9999';
    }
  }
}

export { FormatMask };
